import { TranslateService } from '@ngx-translate/core';

/**
 * Merge feature-module i18n into ngx-translate without "stealing" unloaded languages.
 *
 * ngx-translate's setTranslation(lang, data, true) only deep-merges when
 * translations[lang] already exists; otherwise it overwrites the whole table.
 * Feature modules previously called setTranslation for all 7 langs on init,
 * which permanently blocked AppTranslateLoader from loading global
 * src/assets/i18n/*.ts for unused langs — so common.* (e.g. common.close) broke.
 *
 * This helper: merge immediately if the lang is already loaded; otherwise load
 * the global pack first via getTranslation, then merge the feature pack.
 *
 * @see docs/i18n-key-normalization-guide.md §2.7
 */
export function mergeFeatureI18n(
  translate: TranslateService,
  featureI18n: { [lang: string]: object }
): void {
  Object.keys(featureI18n).forEach((lang: string) => {
    const data = featureI18n[lang];
    if (!data) {
      return;
    }
    if ((translate as any).translations[lang]) {
      translate.setTranslation(lang, data, true);
      return;
    }
    translate.getTranslation(lang).subscribe(() => {
      translate.setTranslation(lang, data, true);
    });
  });
}

/**
 * capa-management style: Object.values(capaI18n) => [{ lang, data }, ...]
 */
export function mergeFeatureI18nLocales(
  translate: TranslateService,
  locales: Array<{ lang: string; data: object }>
): void {
  const asMap: { [lang: string]: object } = {};
  locales.forEach((locale) => {
    if (locale && locale.lang && locale.data) {
      asMap[locale.lang] = locale.data;
    }
  });
  mergeFeatureI18n(translate, asMap);
}
